// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reg--steps{margin:1em auto;width:95%;font-size:16px}", ""]);
// Exports
module.exports = exports;
